const MarqueeItem = ({ logo = "", image = "", icon = "", name = "" }) => {
  return (
    <div
      className="w-full px-[8px] md:px-[16px] flex flex-col"
      style={{ userSelect: "none" }}
    >
      <div className="w-full bg-[#F7F5F1] rounded-[12px] pt-[100%] relative">
        {/* <div
          className='bg-white bg-cover bg-center rounded-full w-[32px] h-[32px] md:w-[52px] md:h-[52px] absolute top-[16px] right-[16px]'
          style={{
            backgroundImage: `url(${logo})`
          }}
        /> */}
        <img
          alt="pill"
          src={image}
          className="absolute top-[0] left-[0] h-full w-full object-cover"
          draggable="false"
        />
      </div>
      <div className="flex mt-[24px] gap-[6px]">
        <img
          src={icon}
          alt="pill"
          className="md:h-[30px] h-[21px]"
          draggable="false"
        />
        <p className="font-[CentraNo2] title font-extrabold">{name}</p>
      </div>
    </div>
  );
};

export const HairLossMarqueeItem = ({
  logo = "",
  image = "",
  icon = "",
  name = "",
}) => {
  return (
    <div
      className="w-full px-[8px] md:px-[16px] flex flex-col"
      style={{ userSelect: "none" }}
    >
      <div className="w-full bg-[#F7F5F1] rounded-[12px] pt-[100%] relative">
        {/* <div
          className="bg-white bg-cover bg-center rounded-full w-[32px] h-[32px] md:w-[52px] md:h-[52px] absolute top-[16px] right-[16px]"
          style={{
            backgroundImage: `url(${logo})`,
          }}
        /> */}
        <img
          alt="pill"
          src={image}
          className="absolute top-[0] left-[0] h-full w-full object-contain"
          draggable="false"
        />
      </div>
      <div className="flex mt-[24px] gap-[6px]">
        <img
          alt="pill"
          src={icon}
          className="md:h-[30px] h-[21px]"
          draggable="false"
        />
        <p className="font-[CentraNo2] title font-extrabold">{name}</p>
      </div>
    </div>
  );
};

export default MarqueeItem;
